import SelectGrid, { SelectGridItem } from "../components/selectGrid/SelectGrid";
import { POSOnboardSetup } from "../useApplyOnboardSetup";
import { Dispatch, SetStateAction } from "react";
import "./style.scss";
import "./step-layout-styles.scss";
import { layoutStyles, LayoutStyle } from "../starterTemplates/layoutStyles";
import { IconTitle } from "../components/smallComponents/IconTitle";
import OliverText from "@builder/components/general/OliverText";

interface StepStylesProps {
    posOnboardSetup: POSOnboardSetup;
    setPOSOnboardSetup: Dispatch<SetStateAction<POSOnboardSetup>>;
}

const SingleLayoutStyle = ({ layout }: { layout: LayoutStyle }) => {
    const { themeStyles } = layout;

    const getTinyBorderRadius = (radius?: string): string | undefined => {
        if (!radius) return undefined;
        if (radius.includes("%")) return radius;
        // for like "0px 0px 0p 0px" kinda things
        return radius
            .trim()
            .split(/\s+/)
            .map(part => {
                const match = part.match(/^(\d+)(px)?$/i);
                if (match) {
                    const num = parseInt(match[1], 10) / 2;
                    return `${num}px`;
                }
                return part;
            })
            .join(" ");
    };

    const tinyShapeStyle: React.CSSProperties = {
        borderRadius: getTinyBorderRadius(themeStyles.borderRadius),
    };

    const shapeStyle: React.CSSProperties = {
        borderRadius: themeStyles.borderRadius,
    };

    const gridSquareStyle: React.CSSProperties = {
        borderRadius: themeStyles.borderRadius,
        border: themeStyles.border,
        boxShadow: themeStyles.boxShadow,
    };

    return (
        <div className="single-layout-style">
            <OliverText size="xxs" weight="light">
                {layout.name}
            </OliverText>
            <div className="layout-preview">
                <div className="layout-preview-content">
                    <div className="lp-left">
                        <div className="tiny-shapes">
                            <span className="tiny-shape" style={tinyShapeStyle} />
                            <span className="tiny-shape" style={tinyShapeStyle} />
                            <span className="tiny-shape" style={tinyShapeStyle} />
                        </div>
                        <div className="textlines">
                            <span className="textline short" />
                            <span className="textline short" />
                            <span className="textline short" />
                            <span className="textline" />
                            <span className="textline" />
                            <span className="textline" />
                        </div>
                        <span className="shape btn" style={shapeStyle} />
                    </div>
                    <div className="lp-right">
                        <span className="shape square" style={gridSquareStyle} />
                        <span className="shape square" style={gridSquareStyle} />
                        <span className="shape square" style={gridSquareStyle} />
                        <span className="shape square" style={gridSquareStyle} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const StepLayoutStyles = ({ posOnboardSetup, setPOSOnboardSetup }: StepStylesProps) => {
    const items: SelectGridItem[] = layoutStyles.map(ls => ({
        id: ls.id,
        Node: <SingleLayoutStyle key={ls.id} layout={ls} />
    }));

    const handleSelect = (id: string) => {
        setPOSOnboardSetup(prev => ({
            ...prev,
            selectedLayoutId: id
        }));
    };

    return (
        <div className="single-onboard-step">
            <IconTitle iconUrl="/creepy-eye.svg" title="Select your layout style" subtitle="You can explore more layout styles or choose your own later." />
            <SelectGrid items={items} selectedId={posOnboardSetup.selectedLayoutId} onSelect={handleSelect} />
        </div>
    );
};

export default StepLayoutStyles;
